import { sql } from "drizzle-orm";

import type { WsLink } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { link } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";

export async function bulkUpsertLink(records: WsLink[], deferEmit = false) {
  if (records.length === 0) return;
  const deduped = deduplicateByKeyValue(records, (item) => item.id);
  await bulkInsert(link, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [link.id],
      set: {
        contentId: sql`"excluded"."contentId"`,
        description: sql`"excluded"."description"`,
        image: sql`"excluded"."image"`,
        linkOrder: sql`"excluded"."linkOrder"`,
        title: sql`"excluded"."title"`,
        url: sql`"excluded"."url"`,
      },
    },
  });
  if (!deferEmit) {
    emitTableUpdates(["link"]);
  }
}
